<template lang="html">
  <div class="footer-spacer"></div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.footer-spacer {
  margin: auto;
}
</style>
